import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@env";
import { CursorPageDTO, KanbanDTO } from "@core/models";
import { ColumnStatus } from "@core/models/kanban-column-status";

export interface KanbanFilters {
  licensePlate?: string;
  requestId?: string;
  appointmentSubStatus?: string;
  serviceRequestStatus?: string;
  serviceType?: string;
  period?: string;
}

@Injectable({
  providedIn: "root"
})
export class KanbanService {
  private kanbanUrl = "kanban";

  constructor(private http: HttpClient) {}

  listKanban(
    cursor?: string,
    size: number = 50,
    filters?: KanbanFilters
  ): Observable<CursorPageDTO<KanbanDTO>> {
    let params = new HttpParams().set("size", size.toString());
    if (cursor) {
      params = params.set("cursor", cursor);
    }

    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        if (value !== undefined && value !== null && value !== "") {
          params = params.set(key, value.toString());
        }
      }
    }

    return this.http.get<CursorPageDTO<KanbanDTO>>(
      `${environment.apiUrl}${this.kanbanUrl}`,
      { params }
    );
  }

  getKanbanById(id: number): Observable<KanbanDTO> {
    return this.http.get<KanbanDTO>(
      `${environment.apiUrl}${this.kanbanUrl}/${id}`
    );
  }

  updateKanban(
    id: number,
    subStatus?: string,
    columnStatus?: ColumnStatus
  ): Observable<KanbanDTO> {
    let params = new HttpParams();
    if (subStatus !== undefined) {
      params = params.set("subStatus", subStatus);
    }

    if (columnStatus !== undefined) {
      params = params.set("columnStatus", columnStatus);
    }

    return this.http.put<KanbanDTO>(
      `${environment.apiUrl}${this.kanbanUrl}/${id}`,
      null,
      { params }
    );
  }
}
